import React from 'react'


export function arabicStringChecker (str){
    var arabic = /[\u0600-\u06FF]/;

    return(arabic.test(str)); // displays true

}